(function () {
  'use strict';
  function init(root) {
    if (root.dataset.energyReady) return;
    root.dataset.energyReady = 'true';
    var radios = Array.from(root.querySelectorAll('[data-energy-code][type="radio"]'));
    var nameNodes = root.querySelectorAll('[data-energy-name]:not(input)');
    var codeNodes = root.querySelectorAll('[data-energy-code]:not(input)');
    var powerNodes = root.querySelectorAll('[data-energy-power]:not(input)');
    var announcement = root.querySelector('[data-energy-announcement]');
    function setModel(radio, announce) {
      nameNodes.forEach(function (el) { el.textContent = radio.dataset.energyName; });
      codeNodes.forEach(function (el) { el.textContent = radio.dataset.energyCode; });
      powerNodes.forEach(function (el) { el.textContent = radio.dataset.energyPower + ' kW'; });
      if (announce) announcement.textContent = window.ZinVoltI18n.t("entry_guide_updated_for_name_code_power_11ec3e", {name:radio.dataset.energyName,code:radio.dataset.energyCode,power:radio.dataset.energyPower});
    }
    radios.forEach(function (radio) { radio.addEventListener('change', function () { if (radio.checked) setModel(radio, true); }); });
    setModel(radios.find(function (radio) { return radio.checked; }) || radios[0], false);
    var steps = Array.from(root.querySelectorAll('[data-energy-step]'));
    var links = Array.from(root.querySelectorAll('.zv-energy__toc nav a'));
    var progress = root.querySelector('[data-energy-progress]');
    var stepSelect = root.querySelector('[data-energy-select]');
    stepSelect.addEventListener('change', function () { location.hash = stepSelect.value; });
    var navigation = window.ZVGuideNavigation.create({
      root: root, sections: steps, links: links, select: stepSelect,
      ariaCurrent: 'step',
      selectValue: function (step) { return step.id; },
      onChange: function (step, index) { progress.textContent = window.ZinVoltI18n.t("step_progress", {current:index + 1,total:steps.length}); }
    });
    function revealHash() {
      if (!location.hash) return;
      var target = document.getElementById(location.hash.slice(1));
      if (!target || !root.contains(target)) return;
      if (target.tagName === 'DETAILS') target.open = true;
    }
    window.addEventListener('hashchange', revealHash);
    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;
      var target = document.getElementById(link.hash.slice(1));
      if (target && target.tagName === 'DETAILS') target.open = true;
    });
    revealHash(); navigation.sync();
  }
  function scan(context) {
    if (context.matches && context.matches('[data-energy-guide]')) init(context);
    context.querySelectorAll('[data-energy-guide]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
